import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  // Chave obtida do environment (diferente para dev/prod)
  private readonly secretKey: string;

  constructor() {
    this.secretKey = environment.cryptoKey;

    // Validar que a chave existe
    if (!this.secretKey && environment.enableDebugLogs) {
      console.error('[CryptoService] ERRO CRÍTICO: Chave de criptografia não configurada!');
    }
  }

  /**
   * Criptografa um valor usando AES com formato padrão CryptoJS
   * @param value Valor a ser criptografado
   * @returns Valor criptografado
   */
  encrypt(value: string): string {
    if (!value) return '';

    try {
      // Usar formato padrão do CryptoJS (já inclui IV internamente)
      const encrypted = CryptoJS.AES.encrypt(value, this.secretKey);
      return encrypted.toString();
    } catch (e) {
      if (environment.enableDebugLogs) {
        console.error('[CryptoService] Erro ao criptografar:', e);
      }
      return '';
    }
  }

  /**
   * Descriptografa um valor criptografado com AES
   * @param encryptedValue Valor criptografado
   * @returns Valor descriptografado
   */
  decrypt(encryptedValue: string): string {
    if (!encryptedValue) return '';

    try {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      // Se não conseguiu descriptografar, retorna vazio
      if (!decrypted) {
        if (environment.enableDebugLogs) {
          console.warn('[CryptoService] Decriptografia retornou vazio - dados possivelmente corrompidos');
        }
        return '';
      }

      return decrypted;
    } catch (e) {
      if (environment.enableDebugLogs) {
        console.error('[CryptoService] Erro ao descriptografar:', e);
      }
      return '';
    }
  }

  /**
   * Gera um hash SHA-256 de um valor
   * Útil para comparações seguras sem expor o valor original
   */
  hash(value: string): string {
    if (!value) return '';
    return CryptoJS.SHA256(value).toString(CryptoJS.enc.Hex);
  }
}
